// extracted by mini-css-extract-plugin
export var chatHtmlText = "_jr-2";
export var chatLink = "_jr-0";
export var chatText = "_jr-1";